import type { Board } from "../board";
import type { Direction } from "../direction";
import { directionDelta, cycleDirection } from "../direction";
import type { Player } from "../player";
import { Barrier } from "../things/barrier";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { ParticleType } from "../particleType";
import { Weapon } from "../weapon";
import { WeaponVisual } from "../weaponVisual";

export class BarrierGun extends Weapon {
	static key = "BarrierGun";
	constructor(owner: Player, ammo: number = 5) {
		super(owner, ammo);
	}

	override getMuzzleFlashType(): ParticleType {
		return ParticleType.MUZZLE_FLASH_PURPLE_WIDE;
	}

	override getMuzzleFlashCount(): number {
		return 20;
	}

	override canAutoFire(): boolean {
		return false;
	}

	override getWeaponVisual(): WeaponVisual {
		return WeaponVisual.DEPLOYER;
	}

	fire(direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.SHOT_SOLIDIFIER));
		const directions = [cycleDirection(direction, -1), direction, cycleDirection(direction, 1)];

		for (const dir of directions) {
			const targetXY = this.owner.xy.add(directionDelta(dir));
			if (!board.isInBounds(targetXY)) continue;
			if (!board.isPassable(targetXY)) continue;
			if (board.hasMob(targetXY)) continue;
			board.addThing(new Barrier(targetXY));
		}
	}

	static deserialize(data: any, owner: Player): BarrierGun {
		const gun = new BarrierGun(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
